import { createApiClient } from '../../api';
import { isKnownKey } from '../catalog';
import { reportAccess } from '../reporting';

import { ACCESS_ENDPOINTS } from './endpoints';
import { errorFrom } from './http';
import { parseMe } from './schemas';
import type { MePayload } from './schemas';

const { request } = createApiClient({ toError: errorFrom });

const ME_TIMEOUT_MS = 8_000;

const unknownKeysIn = (payload: MePayload): readonly string[] => {
  const keys = [...payload.adminKeys, ...payload.baseKeys, ...Object.values(payload.plants).flatMap((plant) => Object.keys(plant.deltas))];
  return [...new Set(keys.filter((key) => !isKnownKey(key)))].sort();
};

export const fetchMePayload = async (signal?: AbortSignal): Promise<MePayload> => {
  const payload = parseMe(await request('get', ACCESS_ENDPOINTS.ME, { signal, timeoutMs: ME_TIMEOUT_MS }));
  const unknown = unknownKeysIn(payload);
  if (unknown.length > 0) reportAccess({ kind: 'unknown-keys', keys: unknown });
  return payload;
};
